import React from 'react';
import styles from './styles.module.scss';

import { LoadIcon } from '@svgs';

const getIcon = ({ name }) => {
  switch (name) {

  case 'photos-mini':
    return <LoadIcon name="PhotosMini" />;
    
  default:
    throw new Error(`Unknown icon in tag ${name}`);
  }
};

export const Tag = ({ type, children, shape, icon = false }) => {
  return (
    <div
      className={`${styles.infoHolder} ${styles[type]} ${styles[shape]} ${
        !!icon && styles.hasIcon
      }`}
    >
      {children}
      {icon && getIcon({ name: icon })}
    </div>
  );
};
